import type { UseFormReturn } from 'react-hook-form';
import type { ExtractStringArrayKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import { getUserDisplayName, useUserActions } from '../../../../resource/resources/persistables/user/userResource';
import { Form_PropertyFieldArrayReference } from '../reference-text-fields/Form_PropertyFieldArrayReference';

export const Form_UserFieldArray = <T extends object>({
                                                          name,
                                                          form,
                                                          readOnly,
                                                          disabled,
                                                          label,
                                                      }: {
    form: UseFormReturn<T>;
    readOnly: boolean;
    disabled?: boolean;
    name: ExtractStringArrayKeys<T, false>;
    label: string;
}) => {
    const userActions = useUserActions();
    const usersQuery = userActions.useGetAllResources();

    return (
        <Form_PropertyFieldArrayReference
            idSelector={'id'}
            control={form.control}
            name={name}
            query={usersQuery}
            readOnly={readOnly}
            label={label}
            disabled={disabled}
            labelAccessor={getUserDisplayName}
            propertyValidation={undefined}
            propertyDetails={undefined}
            uniqueSelection={true}
            initialOpen={true}
            withoutDuplicates={true}
            withSearch={true}
        />
    );
};
